<template>
  <div class="bg-white radius-medium pd-medium br-1px br-grey-transp-15">
    <div class="d-flex flex-v-center flex-justify-between mn-b-regular">
      <div>
        <h4 class="h6 mn-b-thin">{{ subscription.plan?.name || $t('subscriptions.title') }}</h4>
        <p class="p-small" :class="statusColor">{{ $t(`subscriptions.statuses.${subscription.status}`) }}</p>
      </div>
      <p class="p-medium fw-medium">{{ formattedAmount }}</p>
    </div>

    <div v-if="subscription.status !== 'canceled'" class="d-flex flex-justify-between pd-b-small mn-b-small br-b-1px br-grey-transp-15">
      <span class="p-small t-grey">{{ $t('subscriptions.nextBilling') }}</span>
      <span class="p-small fw-medium">{{ formattedNextBilling }}</span>
    </div>

    <div v-if="subscription.cancelAtPeriodEnd" class="pd-small bg-light radius-small mn-b-small">
      <p class="p-small t-grey">{{ $t('subscriptions.cancelAtEnd') }}</p>
    </div>

    <div v-if="['active', 'trial', 'past_due'].includes(subscription.status)" class="d-flex gap-small">
      <button
        v-if="subscription.status === 'active'"
        class="pd-l-small pd-r-small pd-t-thin pd-b-thin p-small radius-small bg-light hover-bg-light t-grey cursor-pointer"
        @click="$emit('pause', subscription._id)"
      >
        {{ $t('subscriptions.pause') }}
      </button>
      <button
        v-if="subscription.status === 'paused'"
        class="pd-l-small pd-r-small pd-t-thin pd-b-thin p-small radius-small bg-main t-white cursor-pointer"
        @click="$emit('resume', subscription._id)"
      >
        {{ $t('subscriptions.resume') }}
      </button>
      <button
        class="pd-l-small pd-r-small pd-t-thin pd-b-thin p-small radius-small bg-light hover-bg-light t-red cursor-pointer"
        @click="$emit('cancel', subscription._id)"
      >
        {{ $t('subscriptions.cancel') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  subscription: { type: Object, required: true },
});

defineEmits(['cancel', 'pause', 'resume']);

const formattedAmount = computed(() => {
  const plan = props.subscription.plan;
  if (!plan) return '';
  const value = plan.amount?.value || 0;
  const currency = plan.amount?.currency || 'RUB';
  return `${(value / 100).toLocaleString('ru-RU')} ${currency === 'RUB' ? '₽' : currency}`;
});

const formattedNextBilling = computed(() => {
  const d = new Date(props.subscription.nextBillingDate);
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
});

const statusColor = computed(() => {
  const colors = {
    trial: 't-second',
    active: 't-main',
    past_due: 't-red',
    paused: 't-grey',
    canceled: 't-grey',
  };
  return colors[props.subscription.status] || 't-dark';
});
</script>
